import { DirectionalHint, TooltipDelay, TooltipHost } from "@fluentui/react";
import React, { useContext, useState } from "react";
import { useTranslation } from "react-i18next";
import GetToolSVG from "./GetToolSVG";
import ViewportContext from "../../../../../context/studyviewer/ViewportContext";
import { resizeViewport } from "../../../helpers/CornerstoneViewportService";
import { isMobile } from "react-device-detect";
import { purgeVolumeCache } from "../../../helpers/CornerstoneService";
import { WindowLevelTool, ZoomTool } from "@cornerstonejs/tools";
import WindowLevelToolComponent from "./WindowLevelToolComponent";
import ZoomToolComponent from "./ZoomToolComponent";
import { logAmplitudeEventWithUsernameAndRole } from "../../../../../helpers/Amplitude";
import userContext from "../../../../../context/users/UserContext";
import CustomToolTipHost from "../../../../../components/CustomToolTipHost/CustomToolTipHost";
const toolStyle = {
  margin: `${isMobile ? "0px" : "0 5px"}`,
  height: "100%",
  width: "fit-content",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
};

const toolTipStyles = {
  root: {
    height: "100%",
  },
};
const MPRTool = ({ tool }) => {
  const {
    setIsMPRActive,
    activeMPRTool,
    setActiveMPRTool,
    setPreviousActiveMPRTool,
    isMPRCineEnabled,
    setIsMPRCineEnabled,
    isMPREnabled,
    handleDefaultToolChange
  } = useContext(ViewportContext);
  const { username } = useContext(userContext);
  const { t } = useTranslation();
  const [hovered, setHovered] = useState(false);
  const handleMouseOver = () => {
    console.log("Handle Mouse over");
    setHovered(true);
  };

  const handleMouseLeave = () => {
    setHovered(false);
  };

  const changeTool = async (tool) => {
    if (tool.key === "EXITMPR") {
      setIsMPRActive(false);
      purgeVolumeCache();
      await resizeViewport();
    } else if (tool.key === "CINE") {
      if (tool.isEvent && !isMPRCineEnabled) {
        logAmplitudeEventWithUsernameAndRole(tool.eventName, {}, username);
      }
      setIsMPRCineEnabled(!isMPRCineEnabled);
    } else {
      if (activeMPRTool === tool.key) {
        setPreviousActiveMPRTool(activeMPRTool);
        handleDefaultToolChange();
      } else {
        setPreviousActiveMPRTool(activeMPRTool);
        setActiveMPRTool(tool.key);
        if (tool.isEvent) {
          logAmplitudeEventWithUsernameAndRole(tool.eventName, {}, username);
        }
      }
    }
  };

  return (
    <CustomToolTipHost
      delay={TooltipDelay.zero}
      id={tool.key}
      directionalHint={DirectionalHint.bottom}
      styles={toolTipStyles}
      content={isMobile ? "" : t(tool.name)}
    >
      <div
        onClick={isMPREnabled ? () => changeTool(tool) : undefined}
        onMouseOver={isMPREnabled ? handleMouseOver : undefined}
        onMouseLeave={isMPREnabled ? handleMouseLeave : undefined}
        style={{
          ...toolStyle,
          justifyContent: `${isMobile ? "flex-start" : "center"}`,
          opacity: isMPREnabled ? 1 : 0.5, // Dim the tool if disabled
          pointerEvents: isMPREnabled ? "auto" : "none", // Disable interactions
        }}
        aria-describedby={tool.key}
      >
        {isMobile ? (
          <>
            <div
              style={{
                height: "65%",
                width: "60px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <GetToolSVG toolName={tool.key} hovered={hovered} />
            </div>
            <span
              style={{
                fontSize: "8px",
                lineHeight: "100%",
                fontWeight: "400",
                color: "#FFFFFF",
              }}
            >
              {t(tool.name)}
            </span>
          </>
        ) : (
          <>
            {tool.key === WindowLevelTool.toolName ? (
              <WindowLevelToolComponent toolName={tool.key} hovered={hovered} />
            ) : (
              <div className="highlight-tool">
                <GetToolSVG toolName={tool.key} hovered={hovered} />
              </div>
            )}
          </>
        )}
      </div>
    </CustomToolTipHost>
  );
};

export default MPRTool;
